/**
 * Profile module store — insured details / contacts / locations + their
 * per-fetch status flags. Profile page reads the three lists; nothing
 * else touches them.
 */
class ProfileStore {
  #listeners = new Set();

  #insuredDetails = null;
  #insuredDetailsLoading = false;
  #insuredDetailsError = null;

  #insuredContacts = [];
  #insuredContactsLoading = false;
  #insuredContactsError = null;

  #insuredLocations = [];
  #insuredLocationsLoading = false;
  #insuredLocationsError = null;

  get insuredDetails() { return this.#insuredDetails; }
  set insuredDetails(v) { this.#insuredDetails = v; this.#notify(); }

  get insuredDetailsLoading() { return this.#insuredDetailsLoading; }
  set insuredDetailsLoading(v) { this.#insuredDetailsLoading = !!v; this.#notify(); }

  get insuredDetailsError() { return this.#insuredDetailsError; }
  set insuredDetailsError(v) { this.#insuredDetailsError = v; this.#notify(); }

  get insuredContacts() { return this.#insuredContacts; }
  set insuredContacts(v) { this.#insuredContacts = v; this.#notify(); }

  get insuredContactsLoading() { return this.#insuredContactsLoading; }
  set insuredContactsLoading(v) { this.#insuredContactsLoading = !!v; this.#notify(); }

  get insuredContactsError() { return this.#insuredContactsError; }
  set insuredContactsError(v) { this.#insuredContactsError = v; this.#notify(); }

  get insuredLocations() { return this.#insuredLocations; }
  set insuredLocations(v) { this.#insuredLocations = v; this.#notify(); }

  get insuredLocationsLoading() { return this.#insuredLocationsLoading; }
  set insuredLocationsLoading(v) { this.#insuredLocationsLoading = !!v; this.#notify(); }

  get insuredLocationsError() { return this.#insuredLocationsError; }
  set insuredLocationsError(v) { this.#insuredLocationsError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#insuredDetails = null;
    this.#insuredDetailsLoading = false;
    this.#insuredDetailsError = null;
    this.#insuredContacts = [];
    this.#insuredContactsLoading = false;
    this.#insuredContactsError = null;
    this.#insuredLocations = [];
    this.#insuredLocationsLoading = false;
    this.#insuredLocationsError = null;
    this.#notify();
  }
}

const profileStore = new ProfileStore();
export default profileStore;
